<template>
  <!-- NOTE (TEMPLATE) to show & edit university profile -->
  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <v-card>
      <v-container>
        <b-form-group label="رمز عبور فعلی">
          <b-form-input
            trim
            v-model="oldPassword"
            type="password"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="رمز عبور جدید">
          <b-form-input
            trim
            v-model="password"
            @input="passStrength"
            type="password"
          ></b-form-input>
          <br />
          <!--============== checking password =========== -->
          <b-row class="w-50">
            <b-col>
              <!-- NOTE check if the pass has more than 8 charector -->
              <p class="pass" :class="{ 'pass--passed': password.length > 7 }">
                <i
                  class="frmIcon fa"
                  :class="password.length > 7 ? 'fa-check' : 'fa-times'"
                ></i>
                حداقل ۸ نویسه
              </p>
            </b-col>
            <b-col>
              <!-- NOTE check if the pass has uppercase -->
              <p class="pass" :class="{ 'pass--passed': has_uppercase }">
                <i
                  class="frmIcon fa"
                  :class="has_uppercase ? 'fa-check' : 'fa-times'"
                ></i>
                دارای حروف بزرگ باشد
              </p>
            </b-col>
          </b-row>
          <b-row class="w-50">
            <b-col>
              <!-- NOTE check if the pass has lowercase -->
              <p class="pass" :class="{ 'pass--passed': has_lowercase }">
                <i
                  class="frmIcon fa"
                  :class="has_lowercase ? 'fa-check' : 'fa-times'"
                ></i>
                دارای حروف کوچک باشد
              </p>
            </b-col>
            <b-col>
              <!-- NOTE check if the pass has number -->
              <p class="pass" :class="{ 'pass--passed': has_number }">
                <i
                  class="frmIcon fa"
                  :class="has_number ? 'fa-check' : 'fa-times'"
                ></i>
                دارای عدد باشد
              </p>
            </b-col>
          </b-row>

          <!--============== checking password =========== -->
        </b-form-group>
        <b-form-group label="تکرار رمز عبور جدید">
          <b-form-input
            trim
            v-model="repeatPassword"
            type="password"
            aria-describedby="repeat-password"
            :state="checkPassword"
          ></b-form-input>
          <b-form-invalid-feedback id="repeat-password"
            >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
          >
        </b-form-group>
        <b-row>
          <b-col>
            <b-button
              @click="changePassword()"
              variant="primary"
              class="text-light"
              :disabled="isBusy || checkPassword == false"
              >تغییر رمز</b-button
            >
          </b-col>
          <b-col> </b-col>
        </b-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      password: "",
      repeatPassword: "",
      oldPassword: "",
      isBusy: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      rec_has_number: false,
      rec_has_lowercase: false,
      rec_has_uppercase: false,
    };
  },
  methods: {
    passStrength() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
      this.rec_has_number = /\d/.test(this.newPass);
      this.rec_has_lowercase = /[a-z]/.test(this.newPass);
      this.rec_has_uppercase = /[A-Z]/.test(this.newPass);
    },
    changePassword() {
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
      ) {
        this.$bvModal.show("loading");
        this.isLoaded = false;
        // NOTE (m-changePassword) to change the password
        this.isBusy = true;

        this.isBusy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/university/profile/changePassword",
            {
              newPassword: md5(this.password),
              password: md5(this.oldPassword),
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.isBusy = false;
            this.toast(res.data, "success");
            this.$bvModal.hide("loading");
            this.password = "";
            this.repeatPassword = "";
            this.oldPassword = "";
            this.has_uppercase = false;
            this.has_lowercase = false;
            this.has_number = false;
          })
          .catch((err) => {
            this.isBusy = false;
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
  },
  computed: {
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.password == this.repeatPassword ? null : false;
    },
    // NOTE this func check if the password has lowecase,uppercase and number
  },
};
</script>
<style lang="scss">
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
</style>
